/**
 * Browser-specific Blob prototype extensions
 *
 * These extensions use browser-only APIs (FileReader) and cannot be
 * moved to switch-core. Other platforms will need their own implementations.
 */

// @ts-ignore
import { md5 } from "hash-wasm";
import ErrorLogger from "../errorLogger";

declare global {
  interface Blob {
    toUint8Array(): Promise<Uint8Array>;
    calculateMD5(): Promise<string>;
  }
}

Blob.prototype.toUint8Array = function toUint8Array(
  this: Blob,
): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      // @ts-ignore
      const arrayBuffer = event.target.result;
      // @ts-ignore
      const uint8Array = new Uint8Array(arrayBuffer);
      resolve(uint8Array);
    };

    reader.onerror = function (event) {
      // @ts-ignore
      reject(new Error("Error reading Blob: " + event.target.error));
    };

    reader.readAsArrayBuffer(this);
  });
};
Blob.prototype.calculateMD5 = async function calculateMD5(
  this: Blob,
): Promise<string> {
  try {
    const arrayBuffer = await this.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    return await md5(uint8Array);
  } catch (error) {
    ErrorLogger.logError(error, "blob.ts");
    console.error("Error calculating MD5 hash:", error);
    throw error;
  }
};
console.log("[ blob.ts ]", "imported");
